import React from 'react';

import {
  BannerWarning,
  PaymentMethods,
  LocaleSelection,
  ServiceCardButton,
  HomeCustomisation,
} from '@fingermarkglobal/cringer.components';

import Logo from '../../../assets/images/logo.svg';
import DineInImage from '../../../assets/images/dinein.svg';
import TakeawayImage from '../../../assets/images/takeaway.svg';
import WashHandsImage from '../../../assets/images/wash-hands.png';
import DefaultBackgroundImage from '../../../assets/images/BG.png';

const PrimaryHome = ({
  t = () => {},
  card,
  cash,
  icons,
  languages = [],
  healthMsg = true,
  className = '',
  primaryAction,
  secondaryAction,
  onChangeLanguage = () => {},
  accessibilityEnabled = false,
  showTermsAndConditionsButton = false,
  setShowTermsAndConditionsModal = () => {},
}) => {
  const isBordered = !!(icons?.length || card);

  return (
    <HomeCustomisation.Provider
      fallback={{
        background: {
          image: DefaultBackgroundImage,
        },
      }}
    >
      <HomeCustomisation.Background />

      <div
        data-test="primary-home"
        className={`z-10 flex flex-col justify-between items-center h-full w-full overflow-y-hidden ${className}`}
      >
        <div
          data-test="home-upper"
          className="flex flex-col items-center justify-start w-full h-full mb-32"
        >
          <PaymentMethods
            t={t}
            card={card}
            cash={cash}
            Logo={Logo}
            icons={icons}
            enableLogo={!accessibilityEnabled}
            className={`px-12 py-4 text-7xl ${isBordered ? 'border-2 border-black' : ''}  rounded ${
              isBordered && !accessibilityEnabled ? 'mt-32' : ''
            }`}
          />
        </div>

        <div
          data-test="home-lower"
          className="flex flex-col-reverse items-center justify-start w-full h-full"
        >
          {showTermsAndConditionsButton && (
            <BannerWarning
              data-test="banner-terms"
              t={t}
              width="109"
              className="w-4/5 mb-2"
              title={t('homeTermsAndConditionsBannerWarningTitle')}
              description={t('homeTermsAndConditionsBannerWarningDescription')}
              additionalDescription={t('homeTermsAndConditionsBannerWarningAdditionalDescription')}
              additionalDescriptionAction={() => setShowTermsAndConditionsModal(true)}
            />
          )}

          {healthMsg && (
            <BannerWarning
              data-test="banner-health"
              t={t}
              width="109"
              image={WashHandsImage}
              className="w-4/5 mb-2"
            />
          )}

          <div
            data-test="home-services"
            className={`flex items-stretch justify-center w-4/5 ${
              healthMsg ? 'mb-32' : 'mb-72'
            } space-x-16`}
          >
            {!!secondaryAction && (
              <ServiceCardButton
                className="w-1/2 shadow-lg bg-white rounded-3xl"
                data-test="button-secondary"
                onClick={secondaryAction}
              >
                <div className="mt-4">{t('homeSecondaryAction')}</div>
                <DineInImage className="w-64" />
              </ServiceCardButton>
            )}

            {!!primaryAction && (
              <ServiceCardButton
                className="w-1/2 shadow-lg bg-white rounded-3xl"
                data-test="button-primary"
                onClick={primaryAction}
              >
                <div className="mt-4">{t('homePrimaryAction')}</div>
                <TakeawayImage className="w-32" />
              </ServiceCardButton>
            )}
          </div>
        </div>

        <div className="flex justify-center w-full mt-8" data-test="home-footer">
          <LocaleSelection languages={languages} onChangeLanguage={onChangeLanguage} />
        </div>
      </div>
    </HomeCustomisation.Provider>
  );
};

export { PrimaryHome };
